import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexBox, FlexItem, Space } from '@codex/basics';
import { AddToBasketButton } from '@codex/organisms';

export const FooterWrapperWithSpace = styled(Space)`
  margin-top: 5px;
  background-image: linear-gradient(to top, #ffffff 0%, #ffffff 85%, #f7f7f7 99%, #d8d8d8);
`;

export const TotalSavings = styled.div`
  flex-grow: 1;
  padding: 10px;
  background-color: #ffefef;
  color: ${props => props.theme.colors.price.default};
  text-align: center;
  font-weight: bold;
  font-size: 14px;
`;

export const TotalSavingsPlaceholder = styled.div`
  flex-grow: 2;
`;

export const TotalPrice = styled(Space)`
  padding: 10px ${props => (props.withSaving ? 10 : 20)}px;
  background-color: ${props => props.theme.colors.shades[6]};
  text-align: center;
  font-weight: bold;
  font-size: 14px;
`;

export const PriceDescription = styled.div`
  color: ${props => props.theme.colors.shades[3]};
  font-size: 13px;
  text-align: center;
`;

export const ButtonWrapper = styled(Space)`
  text-align: center;
`;

const BundleFooter = props => (
  <FooterWrapperWithSpace all={{ desktopWide: '20 22', default: '20 10' }}>
    <FlexBox
      alignItems={{ mobile: 'stretch', default: 'center' }}
      direction={{ mobile: 'column', default: 'row' }}
      justifyContent={{ mobile: 'normal', default: !props.totalSaving ? 'flex-end' : '' }}
      wrap="wrap"
    >
      <FlexItem
        basis={{
          mobile: '100%',
          tablet: '50%',
          desktopSmall: '50%',
          desktopWide: '45%'
        }}
      >
        <FlexBox alignItems="stretch" justifyContent="flex-end">
          {props.totalSaving && (
            <TotalSavings>
              {props.totalSaving}
            </TotalSavings>
          )}

          <FlexItem grow={{ mobile: 1, default: props.totalSaving ? 1 : 0 }} shrink={1}>
            <TotalPrice
              all={{
                mobile: '0 0 0 5',
                tablet: '0 10',
                desktopSmall: '0 10',
                desktopWide: '0 20'
              }}
              property="margin"
              withSaving={props.totalSaving}
            >
              {props.totalPrice}
            </TotalPrice>
          </FlexItem>

        </FlexBox>
      </FlexItem>

      <FlexItem
        basis={{
          mobile: '100%',
          tablet: props.totalSaving ? '50%' : '45%',
          desktopSmall: props.totalSaving ? '50%' : '30%',
          desktopWide: '25%'
        }}
      >
        <ButtonWrapper top={{ mobile: 10 }}>
          {props.children
            ? props.children
            : (
              <AddToBasketButton
                productId={props.bundleId}
                postUrl={window.location.href}
                placement={AddToBasketButton.placements.BUNDLE}
                onFormSubmit={callback => props.onAddToBasket(
                  [props.productId, ...props.addonsIds],
                  props.bundleType,
                  callback
                )}
                renderAdditionalHiddenInputs={() => {
                  const visitorId = window.adobeVisID || 0;
                  const inputs = [
                    <input type="hidden" name="visitorId" value={visitorId} key={visitorId} />
                  ];

                  props.addonsIds.forEach(id => inputs.push(
                    <input type="hidden" name="addonProductsIds[]" value={id} key={id} />
                  ));

                  return inputs;
                }}
              >
                {props.addButtonLabel}
              </AddToBasketButton>
            )}
        </ButtonWrapper>
      </FlexItem>

      <FlexItem
        basis={{
          mobile: '100%',
          tablet: '50%',
          desktopSmall: '50%',
          desktopWide: '30%'
        }}
        order={{
          desktopWide: -1
        }}
      >
        <Space top={{ touch: 10, desktopSmall: 10 }} right={{ desktopWide: 10 }}>
          {props.totalSaving && (
            <PriceDescription>
              {props.priceDescription}
            </PriceDescription>
          )}
        </Space>
      </FlexItem>
    </FlexBox>
  </FooterWrapperWithSpace>
);

BundleFooter.propTypes = {
  addonsIds: PropTypes.arrayOf(PropTypes.string),
  addButtonLabel: PropTypes.string,
  bundleId: PropTypes.string,
  bundleType: PropTypes.string,
  children: PropTypes.element,
  onAddToBasket: PropTypes.func,
  priceDescription: PropTypes.string,
  productId: PropTypes.string,
  totalPrice: PropTypes.string,
  totalSaving: PropTypes.string
};

BundleFooter.defaultProps = {
  addonsIds: [],
  addButtonLabel: '',
  bundleId: '',
  bundleType: '',
  children: undefined,
  onAddToBasket: () => {},
  priceDescription: '',
  productId: '',
  totalPrice: '',
  totalSaving: ''
};

export default BundleFooter;
